import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import { Container, Card, CardContent, Typography, Button, Avatar, Box } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const Profile = () => {
  const { user, setUser } = useContext(UserContext); // Access user data from context
  const navigate = useNavigate();

  // Redirect to login if no user is authenticated
  if (!user) {
    navigate("/login");
    return null;
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 5, mb:4 }}>
      <Card sx={{ p: 3, boxShadow: 3 }}>
        <CardContent sx={{ textAlign: "center" }}>
          <Avatar sx={{ bgcolor: "#42326e", width: 60, height: 60, margin: "0 auto" }}>
            <PersonIcon fontSize="large" sx={{ color:"black" }}/>
          </Avatar>

          <Typography variant="h5" fontWeight="bold" sx={{ mt: 2, color:"#42326e" }}>
            Welcome, {user.name}
          </Typography>

          {/* Displaying User Info */}


          <Box sx={{ mt: 2, alignContent: "center" }}>
            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography variant="body1" color="textSecondary" sx={{ fontWeight: "bold" }}>
                Email:
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {user.email}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography variant="body1" color="textSecondary" sx={{ fontWeight: "bold" }}>
                Contact Number:
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {user.phone}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography variant="body1" color="textSecondary" sx={{ fontWeight: "bold" }}>
                City:
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {user.city}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography variant="body1" color="textSecondary" sx={{ fontWeight: "bold" }}>
                Role:
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {user.role}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", mb: 1 }}>
              <Typography variant="body1" color="textSecondary" sx={{ fontWeight: "bold" }}>
                Status:
              </Typography>
              <Typography variant="body1" color="textSecondary">
                {user.status}
              </Typography>
            </Box>
          </Box>


          {/* Logout Button */}
          <Button
            variant="contained"
            color="error"

            sx={{ mt: 3 }}
            onClick={() => {
              setUser(null);
              navigate("/");
            }}
          >
            Logout
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Profile;
